import React from "react";
import { ProcurementContactsData } from "./InternalNotesResult";
interface Props {
  procurementContactsData: ProcurementContactsData;
}
const ProcurementContacts = ({
  procurementContactsData
}: Props) => {
  const {
    buyerCode,
    buyerCodeEmail,
    categoryAnalyst,
    categoryAnalystEmail,
    categoryManager,
    categoryManagerEmail,
    vendorAnalyst,
    vendorAnalystEmail
  } = procurementContactsData;
  return <div data-testid="procurementContacts" data-sentry-component="ProcurementContacts" data-sentry-source-file="ProcurementContacts.tsx">
      <h4>
        <mark>Procurement Contacts</mark>
      </h4>
      <p data-testid="internal-notes-buyer-code">
        <strong>Buyer Code:</strong>
        <span className="text-gray-800">
          &nbsp;
          {buyerCode}
        </span>
      </p>
      {vendorAnalyst && <p>
          <strong>
            Inventory Management/Product Cost:&nbsp;
            <a href={`mailto:${vendorAnalystEmail}`}>{vendorAnalyst}</a>
          </strong>
        </p>}
      {categoryAnalyst && <p>
          <strong>
            Marketing/Sale Price:&nbsp;
            <a href={`mailto:${categoryAnalystEmail}`}>{categoryAnalyst}</a>
          </strong>
        </p>}
      {categoryManager && <p>
          <strong>
            Product Development:&nbsp;
            <a href={`mailto:${categoryManagerEmail}`}>{categoryManager}</a>
          </strong>
        </p>}
    </div>;
};
export default ProcurementContacts;